import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SelectFormIconComponent } from 'src/app/middleware/common/selectFormIcon/selectFormIcon.component';

@Component({
  selector: 'app-manage-folderForms',
  templateUrl: './manage-folderForms.component.html',
  styleUrls: ['./manage-folderForms.component.scss']
})

export class ManageFolderFormsComponent implements OnInit {

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;


  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList:[],
    officeID:0   
  };
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  folderList: any[]=[];  
  value = ''; 
  paginatorTotalLength: any;
  //dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  spinner:boolean=false;
  taskStatusID:number=0;

  cType:number=1;
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  menuModulesList: any = [] = [];
  folderID:number=0;
  FormReportfolderList: any = [] = [];
  ShowNoRecordFoundForms:boolean=false;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
     private toastr: ToastrService, private statusConst: StatusConstant, 
     private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;     
    }

    SelectedContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;      
    }

    SelectedCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;    
    }
    this.GetFormReportFolderMappings();
    this.GetFormReportFolders(); 
  }


  GetFormReportFolderMappings() {
    var ReqModel = {
      cType:this.cType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.getFormReportFolderMappings(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormReportfolderList = this.responseHolder.data;         
          if(this.FormReportfolderList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
          }
        }
        else {
          this.ShowNoRecordFound=true;
          this.FormReportfolderList=[];
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.FormReportfolderList=[];       
      }
    });
  }
 
   
  GetFormReportFolders() {
    var ReqModel = {
      cType:this.cType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.getFormReportFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormfolderList = this.responseHolder.data;        
        }
        else {          
          this.FormfolderList=[];
        }
      }
      else {      
        this.FormfolderList=[];       
      }
    });
  } 


  UpdateStatusToggle(task: any, event: any) {
    this.loaderService.show();
    var ReqModel = {
      mappingID: task.mappingID,    
      isActive: event.checked,
      organizationID: Number(this.organizationId),  
      userID: this.currentUser.UID,  
      officeID:this.myOfficeID,
    }
     this.settingsService.activateFormReportFolderMapping(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Status updated successfully.', '', {
            timeOut: 3000,
          });
          this.GetFormReportFolderMappings();
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
          this.toastr.error('Status update failed.', '', {
            timeOut: 3000,
          });
        }
      }else{
        this.loaderService.hide();
        this.toastr.error('Status update failed.', '', {
          timeOut: 3000,
        });
      }
    });
   }

 

  deleteFolderForm(forms: any) { 
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel ={
          mappingID: forms.mappingID,        
          organizationID: Number(this.organizationId),  
          userID: this.currentUser.UID,  
          officeID:this.myOfficeID,
        }        
        this.settingsService.removeFormReportFolderMapping(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Form deleted successfully.', '', {
                timeOut: 3000,
              });
              this.GetFormReportFolderMappings();
              this.loaderService.hide();
            }
          }
        });
      }
    });
  }  
  
  close() {
    this.formDialog.reset();    
    this.dialog.closeAll();
  }  


  selectForm(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });
    this.formAlias="";
    this.formIcon="";
    this.iconName="";
    this.selectedFolderId=0;
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.SharedWithMeactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.FormFolderListMiddleSection=[];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  closeForms() {   
    // For Import Template //
    this.menuHeader = [];
    this.FormFolderListMiddleSection = [];
    this.FormFolderList = [];
    this.activeNode = "";
    this.SharedWithMeactive = false;
    this.selectButtonShow = false;   

    this.dialog.closeAll();
  }

  //================== For Forms ====================//

  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;
  selectButtonShow: boolean = false;
  PlaceholderName: string = "";
  PlaceholderID: string = "";
  DocumentFolderID: string = "";
  FormID: string = "";
  fileManagerID: string = "";
  PlaceholderNameFound: boolean = false;
  SharedWithMeFormFolderList: any = [] = [];
  SharedWithMeMyDriveFolderList: any = [] = [];
  isShowForm: any = true;
  isSharedWithMe: any = false;
  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  SharedWithMeactive: boolean = false;
  SharedWithMeMyDriveactive: boolean = false;
  menuHeaderMyDrive: any = [];
  menuHeader: any = [];
  databaseId: string;
  FormFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);
  parentID: number = 0;
  TypeId: number;
  selectedForms:any=[]=[];

  radioChange(form, FormOrShared) {
    this.selectedForms=[];
    // if (FormOrShared == "SharedWithMe") {
    //   this.activeNode = "";
    //   this.SharedWithMeFormFolderList.forEach(e => {
    //     e.isChecked = false
    //   });
    // }
    if (FormOrShared == "MyForm") {
      this.FormFolderListMiddleSection.forEach(e => {
        e.isChecked = false
      });
    }

    if (form.type == 1 && FormOrShared == "MyForm") {
      this.selectButtonShow = false;
      this.getform(form, FormOrShared);
    }

    if (form.type == 2) {
      if (this.PlaceholderNameFound == true) {
        this.PlaceholderName = form.name;
        if (this.PlaceholderID == undefined)
          this.PlaceholderID = "0";
      }
      this.FormID = form.id;
      this.selectButtonShow = true;
      if (FormOrShared == "MyForm") {
        this.FormFolderListMiddleSection.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
      // if (FormOrShared == "SharedWithMe") {
      //   this.SharedWithMeFormFolderList.forEach(e => {
      //     if (e.id == form.id) {
      //       e.isChecked = true
      //     }
      //   });
      // }
      this.selectedForms= form;
      
    }
  }

  getform(form, FormOrSharedWithMe) {
    if (FormOrSharedWithMe == "MyForm") {
      this.activeNode = form.id;
    }
    if (FormOrSharedWithMe == "SharedWithMe") {
      this.activeNode = "";
    }
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.FormFolderListMiddleSection = this.responseHolder.data;           
            this.FormFolderListMiddleSection=this.FormFolderListMiddleSection.filter(x=>x.type == 2 && x.formType==3);
     
            this.parentID = form.id;

            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
            });

            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

          } else {
          }
        } else {
        }
      });
    } else {
    }
  }

  breadCrumb(menu, index) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getformnavigate(data);
    this.selectButtonShow = false;
    this.parentID = data.id;
  }


  getformnavigate(form) {
    this.selectButtonShow = false;
    this.activeNode = form.id;
    var ReqModel = {
      formFolderID: form.id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormFolderListMiddleSection = this.responseHolder.data;  
          this.FormFolderListMiddleSection=this.FormFolderListMiddleSection.filter(x=>x.type == 2 && x.formType==3);
        } else {
        }
      } else {
      }
    });
  }

  GetAllForms() {
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  getFormFolderListLeftPanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.settingsService.getFormFolderList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });

  }

  getFormFolderListMiddlePanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderListMiddleSection = this.responseHolder.data;        
          this.FormFolderListMiddleSection.forEach(e => {
            e.isChecked = false
          });
        } else {
        }
      } else {
      }
    });
  }

  getFormFolderWithTemplatesLeftPanel(form) {
    this.selectButtonShow = false;
    this.activeNode = form.formFolderID;
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormsubFolderFolderList = this.responseHolder.data;          
          this.FormsubFolderFolderList=this.FormsubFolderFolderList.filter(x=>x.type == 2 && x.formType==3);
  
          this.settingsService.GetParentFormFolderHierarchy(ReqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.hierarchyList = response.data.hierarchy;
                if (this.hierarchyList == null || this.hierarchyList == undefined) {
                  this.breadCrumMenu = [];
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                } else {
                  this.breadCrumMenu = [];
                  this.hierarchyList.forEach(e => {
                    this.breadCrumMenu.push({ label: e.formFolderName, id: e.formFolderID, icon: 'navigate_next' });
                  });
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  if(this.FormFolderListMiddleSection.length>0){
                    this.ShowNoRecordFoundForms=true;
                  }else{
                    this.ShowNoRecordFoundForms=false;
                  }
                  this.parentID = form.parentID;
                  this.isShowForm = true;
                  this.isSharedWithMe = false;
                  this.SharedWithMeactive = false;
                }
              }
            }
          });
        }
        else {
        }
      }
      else {
      }
    });

  }
 

  breadCrumbMainClick() {
    this.FormFolderListMiddleSection = [];
    this.getFormFolderListMiddlePanel();
    this.menuHeader = [];
    this.TypeId = 0;
    this.parentID = 0;
    this.selectButtonShow = false;
    this.activeNode = "";
  }

  

  ///============ For add Form Folder ===================//

 selectedFolderId:number=0;
 formIcon:string="";
 formAlias:string="";
 FormfolderList:any=[]=[];
 iconName:string="";

  SelectFormSubmit() {
    var checkData:any=[]=[];
    checkData = this.FormReportfolderList.filter(x=>x.formID == this.FormID);
    if(checkData.length>0){
      this.toastr.warning('Form allready added,please select another.', '', {
        timeOut: 3000,
      });
      return;
    }
    if(this.formAlias==""){
      this.toastr.warning('Please add alias name.', '', {
        timeOut: 3000,
      });
      return;
    }
    if(this.formIcon==""){
      this.toastr.warning('Please choose form icon.', '', {
        timeOut: 3000,
      });
      return;
    }
    if(this.selectedFolderId==0){
      this.toastr.warning('Please select folder.', '', {
        timeOut: 3000,
      });
      return;
    }
    //var icon:string="";
    //var formIcon = this.formIcon;
    //var icon = `<mat-icon>${formIcon}</mat-icon>`;
    let ReqModel = {
      folderID: this.selectedFolderId,
      formID: this.FormID,
      formIcon: this.formIcon,
      formAlias: this.formAlias,
      position: (this.FormReportfolderList.length+1),      
      organizationID: Number(this.organizationId),    
      userID: this.currentUser.UID,    
      officeID:this.myOfficeID,
    }
    this.loaderService.show();      
    this.settingsService.addFormReportFolderMapping(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner=false; 
          this.dialog.closeAll();
          this.toastr.success('Form added successfully.', '', {
            timeOut: 3000,
          });
          this.GetFormReportFolderMappings();
          this.loaderService.hide();
        }else{          
          this.loaderService.hide(); 
        }
      }else{       
        this.loaderService.hide(); 
      }
    });
  }
  

  OnChange3C($event) {    
    this.cType=Number($event.value); 
    this.GetFormReportFolders();  
    this.GetFormReportFolderMappings(); 
  }
 

  selectFolder(e:any){
    this.selectedFolderId=Number(e.value);
  }


  selectIcon(){
    const dialogRef = this.dialog.open(SelectFormIconComponent, {    
     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.formIcon = result.icon;
       // this.iconName = result.name;  
      }
    }); 
  }







  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.FormReportfolderList, event.previousIndex, event.currentIndex);
    var record:any=[]=[];
    var reOrdersList:any=[]=[];
    record = this.FormReportfolderList;
    if(record.length>0){     
      reOrdersList=[];
      for (let i = 0; i < record.length; i++) {     
        var obj={
          mappingID: record[i].mappingID,          
          position: i+1
        }
        reOrdersList.push(obj);
      }     

      var reqModel={
        cType:this.cType,       
        formOrdering:reOrdersList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.loaderService.show();
      this.settingsService.reorder3CForms(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {          
            this.GetFormReportFolderMappings();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  //===========Edit ==============//

  mappingID:number=0;

  UpdateTaskDialog(templateRef: TemplateRef<any>, task: any) {
    this.mappingID=task.mappingID;
    this.formAlias=task.formAlias;
    this.formIcon=task.formIcon;
    this.folderID= task.folderID;  
    this.dialog.open(templateRef); 
  }   

  updateFormFolder() {
    let ReqModel = {
     mappingID:this.mappingID,   
     icon: this.formIcon,
     alias: this.formAlias,
     folderID: this.folderID,
     organizationID: Number(this.organizationId),  
     userID: this.currentUser.UID,  
     officeID:this.myOfficeID,
   }
   this.loaderService.show();   
   this.spinner=true;     
   this.settingsService.updateFormFolderMapping(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;
         this.dialog.closeAll();     
         this.toastr.success('Record updated successfully.', '', {
           timeOut: 3000,
         });
         this.GetFormReportFolderMappings();        
         this.loaderService.hide();
       }else{
         this.spinner=false; 
         this.loaderService.hide(); 
         this.toastr.error('Record updated failed.', '', {
          timeOut: 3000,
        });
       }
     }else{
      this.spinner=false; 
      this.loaderService.hide(); 
      this.toastr.error('Record updated failed.', '', {
       timeOut: 3000,
     }); 
     }
   });
  }

  closeUpdate(){
    this.dialog.closeAll();
  }

}

interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}